import { render, staticRenderFns } from "./MonoxidSensorDevicePanel.vue?vue&type=template&id=3b6023a8&lang=pug&"
import script from "./MonoxidSensorDevicePanel.vue?vue&type=script&lang=ts&"
export * from "./MonoxidSensorDevicePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports